// Action Types
export const SET_CLOUD_SSO = 'auth/setCloudSSO'
export const SET_DESKTOP_SSO = 'auth/setDesktopSSO'

// Action Creators
export const setCloudSSO = (payload) => ({ type: SET_CLOUD_SSO, payload })
export const setDesktopSSO = (payload) => ({ type: SET_DESKTOP_SSO, payload })

// State
export const initialState = {
  cloudSSOConfig: {},
  desktopSSOConfig: {},
}

// Reducer
export default function ssoReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CLOUD_SSO:
      return { ...state, cloudSSOConfig: { ...action.payload } }
    case SET_DESKTOP_SSO:
      return { ...state, desktopSSOConfig: { ...action.payload } }
    default:
      return state
  }
}
